const colorObj = {
    survey: '#16CCC1',
    comparison: '#715AF8',
    industry: '#1A81F0',
    company: '#EE2699',
    portfolio: '#009ABD',
    sector: '#DCD200',
    completed: '#16CCC1',
    dropped: '#FEB201',
    screened: '#FE3A29',
    default: '#38A8A1',
    nps: {
        survey: ['#F00','#F00','#F00','#F00','#F00','#F00','#F00','#FF0','#FF0','#009900','#009900'],
        company: ['#fba8a8','#fba8a8','#fba8a8','#fba8a8','#fba8a8','#fba8a8','#fba8a8','#f2f2a4','#f2f2a4','#90e190','#90e190'],
        portfolio: ['#fba8a8','#fba8a8','#fba8a8','#fba8a8','#fba8a8','#fba8a8','#fba8a8','#f2f2a4','#f2f2a4','#90e190','#90e190'],
        industry: ['#f0d9d9','#f0d9d9','#f0d9d9','#f0d9d9','#f0d9d9','#f0d9d9','#f0d9d9','#f4f4c2','#f4f4c2','#c5f6c5','#c5f6c5'],
        sector: ['#f0e4e4','#f0e4e4','#f0e4e4','#f0e4e4','#f0e4e4','#f0e4e4','#f0e4e4','#f4f4e3','#f4f4e3','#e3f6e3','#e3f6e3'],
        comparison: ['#ff7c7c','#ff7c7c','#ff7c7c','#ff7c7c','#ff7c7c','#ff7c7c','#ff7c7c','#fbfb92','#fbfb92','#52c152','#52c152'],
    },
}

function getSerieColour(key, kpiType) {
    let colour
    if (kpiType === 'NPS') {
        colour = colorObj.nps[key]
    } else {
        colour = colorObj[key]
    }
    return colour
}

export default {
    colorObj,
    getSerieColour,
}
